import { Box, Typography } from "@mui/material";
import TextIntegrationStyle from "../../TextIntegrationStyle";
import RelatedUserSection from "./RelatedUserSection";

const ClaudeAPIKeyDetailsView = ({ entityData }) => {
  const claudeApiKeyData = entityData?.claude_api_keys_data;

  const createdByValue =
    claudeApiKeyData?.created_by_user_type === "user"
      ? claudeApiKeyData?.created_by_user_name ||
        claudeApiKeyData?.created_by_user_id
      : claudeApiKeyData?.created_by_user_id;

  return (
    <Box display={"flex"} flexDirection={"column"} gap={2}>
      {entityData?.display_name && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Name</Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle title={""} value={entityData.display_name} />
          </Box>
        </Box>
      )}

      {claudeApiKeyData?.partial_key_hint && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Partial Key Hint</Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle
              title={""}
              value={claudeApiKeyData.partial_key_hint}
            />
          </Box>
        </Box>
      )}

      {claudeApiKeyData?.key_type && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Key Type</Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle
              title={""}
              value={claudeApiKeyData.key_type}
            />
          </Box>
        </Box>
      )}

      {claudeApiKeyData?.workspace_id && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Workspace ID</Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle
              title={""}
              value={claudeApiKeyData.workspace_id}
            />
          </Box>
        </Box>
      )}

      {claudeApiKeyData?.status && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Status</Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle title={""} value={claudeApiKeyData.status} />
          </Box>
        </Box>
      )}

      {(claudeApiKeyData?.created_by_user_id ||
        claudeApiKeyData?.created_by_user_type) && (
        <>
          {claudeApiKeyData?.created_by_user_type === "user" &&
          entityData?.connected_email ? (
            <RelatedUserSection
              entityData={entityData}
              contextName="Claude API key details view"
            />
          ) : (
            <Box display={"flex"} flexDirection={"column"} gap={1}>
              <Box
                display={"flex"}
                flexDirection={"row"}
                alignItems={"center"}
                gap={1}
              >
                <Typography variant={"subtitle2"}>Created By</Typography>
              </Box>
              <Box ml={2} display={"flex"} flexDirection={"column"} gap={0.5}>
                {createdByValue && (
                  <TextIntegrationStyle value={createdByValue} />
                )}
              </Box>
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default ClaudeAPIKeyDetailsView;
